module.exports = __webpack_public_path__ + "static/img/210531osd.704ff76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/210531osd.jpg
// module id = 6v0T
// module chunks = 0